import {PATHS} from '@/src/routes/containers/Routes';

import {
  COURSE_PREVIEW_PAGE,
  REGISTRATION_PAYMENT,
} from '../constants/pagesTypes';

/**
 * @param {string} type - pageType
 * @param {string} id - pageType page to redirect
 */
const getRedirectUrl = (type, id) => {
  const {SIGN_UP_PAYMENT_DETAILS} = PATHS;

  switch (type) {
    case COURSE_PREVIEW_PAGE:
      return `courses/${id}`;

    case REGISTRATION_PAYMENT:
      return SIGN_UP_PAYMENT_DETAILS.getLink();

    default:
      return '/';
  }
};

export default getRedirectUrl;
